import { ISiteSettingsForSiteAdmin } from '../../../settings/types/ISiteSettingsForSiteAdmin';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetSiteSettingsForSiteAdminParams {
  id: string;
}

export interface IGetSiteSettingsForSiteAdminResult extends IResult, ISiteSettingsForSiteAdmin {}


export class GetSiteSettingsForSiteAdminRequest extends Request<IGetSiteSettingsForSiteAdminParams, IGetSiteSettingsForSiteAdminResult> {
  constructor(params: IGetSiteSettingsForSiteAdminParams) {
    super('getSiteSettingsForSiteAdmin', params);
  }
}
